import { useCallback, useEffect, useState } from 'react';
import { useAgent } from '../hooks/useAgent';

const LIMIT = 50;

const ACTION_TONE = {
  auto_sent: 'green', meeting_booked: 'green', unsubscribed: 'blue',
  drafted: 'indigo', escalated: 'amber', skipped: 'gray', error: 'red',
};

export default function AuditTab() {
  const { listActions } = useAgent();
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [offset, setOffset] = useState(0);
  const [error, setError] = useState(null);
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async (off) => {
    setError(null);
    try {
      const data = await listActions({ limit: LIMIT, offset: off });
      setTotal(data.total);
      setRows((prev) => (off === 0 ? data.actions : [...prev, ...data.actions]));
    } catch (e) {
      setError(e?.response?.data?.detail || e.message);
    } finally {
      setLoaded(true);
    }
  }, [listActions]);

  useEffect(() => { load(0); }, [load]);

  if (error) return <div className="agent-empty">{error}</div>;
  if (!loaded) return <div className="agent-loading">Loading…</div>;
  if (rows.length === 0) return <div className="agent-empty">No agent activity yet.</div>;

  const fmt = (ts) => (ts ? new Date(ts).toLocaleString() : '');

  return (
    <div className="agent-section">
      <table className="agent-table">
        <thead>
          <tr><th>Time</th><th>Action</th><th>Intent</th><th>Conf.</th><th>Contact</th><th>Reason</th></tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id}>
              <td className="agent-td-time">{fmt(r.created_at)}</td>
              <td>
                <span className={`agent-action-badge tone-${ACTION_TONE[r.action] || 'gray'}`}>
                  {r.action.replace(/_/g, ' ')}
                </span>
              </td>
              <td>{r.intent || '—'}</td>
              <td>{r.confidence ?? '—'}</td>
              <td>{r.contact_name || '—'}</td>
              <td className="agent-td-reason">{r.skip_reason || '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {rows.length < total && (
        <div className="agent-actions-row">
          <button className="agent-btn" onClick={() => { const n = offset + LIMIT; setOffset(n); load(n); }}>
            Load more ({rows.length}/{total})
          </button>
        </div>
      )}
    </div>
  );
}
